import { FormGroupForResolver } from "db/definitions";
import { batchAddFormGroups } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

async function batchCreateFormGroups(formGroups: FormGroupForResolver[]): Promise<boolean> {
	if (formGroups.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFormGroups,
				variables: { formGroups: formGroups },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateFormGroups;
